<!-- 产品技术参数 -->
<template>
    <div class="product-params-container">
      <div class="table-container">
        <table border="0">
          <tr v-for="(item,index) in productParams" :key="index">
            <td style="width: 20%;text-align: left;padding-left: 5px;">
              <div class="table-cell">
                <span>{{item.title}}</span>
              </div>
            </td>
            <td style="width: 40%;">
              <div class="table-cell">
                <span>{{item.value[0]}}</span>
              </div>
            </td>
            <td style="width: 40%;">
              <div class="table-cell">
                <span>{{item.value[1]}}</span>
              </div>
            </td>
          </tr>
        </table>
        <div class="no-params" v-if="productParams.length == 0">暂且没有参数</div>
      </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {}
    },
    props: {
      productParams: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    created () {

    },
    mounted () {

    },
    methods: {}
  }
</script>

<style lang="scss" scoped>
.product-params-container{
  /*padding: rem(10) 0;*/
  padding-bottom: rem(30);
  .table-container{
    width: 100%;
    table{
      display: table;
      width: 100%;
      border: none;
      font-size: 12px;
      color: #333;
      tr{
        line-height: 28px;
        border-bottom: 1px solid #eaeaea;
        td{
          &:not(:first-child){
            padding: 0 8px;
          }
        }
      }
    }
    .table-cell{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-all;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0 2px;
    }
    .no-params{
      height: rem(45);
      line-height: rem(45);
      text-align: center;
      color: #928e8e;
    }
  }

}
</style>
